import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export const CLE_STOCKAGE_MENUS_ROLE = 'dematral_role_menus';

@Injectable({
  providedIn: 'root'
})
export class RoleMenuConfigService {
  private configMiseAJour$ = new Subject<void>();

  readonly surConfigMiseAJour = this.configMiseAJour$.asObservable();

  notifierConfigMiseAJour(): void {
    this.configMiseAJour$.next();
  }
}
